export default __webpack_public_path__ + "static/media/Rugs.83c8e7e2.png";